<h4>סטטיסטיקות</h4>
<!-- <p>
    אנחנו גאים בטכנולוגיה שלנו שמגיע עד ל98% דיוק - מהגבוהים בעולם!
</p> -->

<div class="statImgContain">
    <div class="statImg">

        <img [src]="'assets/images/Stats tbl.png'" width=50 alt="" loading="lazy" />
    </div>
    <div class="statImg">

        <img [src]="'assets/images/Stats graph.png'" width=50 alt="" loading="lazy" />
    </div>
</div>
<h4>הסבר</h4>
<p>
    דיוק הסריקה היא ביחס ישר לאיכות בתמונה
    <br>
    כלומר ככל שהתמונה: מטושטשת, חשוכה, דהויה, מקומטת או עקומה,

    כך יורדת איכות הסריקה
    <br>
    מצד שני, קיים יחס הפוך בין דיוק הסריקה לאחוז המסכים שאותם לא ניתן לסרוק בוודאות גבוהה
</p>
<p>
    <b>Doc2Txt</b>
    מאפשר למשתמש לבחור את היחס בין הדיוק לוודאות הסריקה לפי הצרכים הספציפיים שלו
    <br>
    כל סריקה מקבלת ציון בין
    <b>0</b>
    (וודאות נמוכה) ל
    <b>100</b>
    (וודאות גבוהה)
    <br>
    כך שהמשתמש יכול לסנן את המסמכים לפי הוודאות הנדרשת
</p>
<p>
    בטבלה ניתן לראות שככל שה
    Threshold
    (דיוק מינימלי)
    הנדרש גבוהה יותר, כך:

</p>
<ul>
    <li>
        <B>

            False Positive
        </B>
        קטן -
        כלומר הדיוק משתפר
    </li>
    <li>
        <B>
            Need Revisit
        </B>
        גדל -
        כלומר מספר המסכים מספר המסמכים שצריכים בדיקה (כיוון שהוודאות עבורם לא הספיקה)
    </li>
</ul>
<h4>פער מחיר - Price Offset</h4>
<p>
    <b>Doc2Txt</b>
    שואפת להקטין את אחוז הטעות אבל לא רק מבחינת הדיוק, אלא גם את אחוז השגיאה במחיר
    <br>
    במטרה להקטין את הסיכון עבור המשתמש
    <br>
    כך שגם אם הדיוק שגוי, הפער בין המחיר ל{{'Value' | i18n}} האמיתי קטן ככל האפשר
    <br>
    בטבלה ניתן לראות שככל שה
    Threshold
    גדל ככה <b>פער המחיר</b> קטן
</p>
<P>
    בגרף ניתן לראות את היחס ההפוך בין הדיוק למספר המסמכים שצריכים בדיקה
</P>
<h4>כיצד מתבצעת הבדיקה</h4>
<p>
    הבדיקה מתבצעת על אלפי חשבוניות שתויגו ידנית
    <BR>
    התמונות מופיעיות באיכיות שונות, כך שב{{'Value' | i18n}} 10% מהתמונות הן באיכות לא מספקת
    <BR>
</p>
<p>
    בטבלה ניתן לראות שכאשר לא מסננים לפי מדד הדיוק
    (Threshold = 0)
    אז השגיאה גדלה למקסימום (9%) ופער המחיר גדל באופן משמעותי
    <BR>
    לכן ההמלצה היא לבחור {{'Value' | i18n}}
    Threshold
    בין 35 ל 50,
</p>
<p>
    <b>

        לרוב הממשתמשים
        Threshold=45
        יהיה אופטימלי, כיוון שאחוז הדיוק מגיע ל 98% ורק 17% דורשים בדיקה
    </b>

</p>